import apiClient from './apiClient';

export const whatsappApi = {
  // Settings
  getSettings: () => apiClient.get('/whatsapp/settings').then(r => r.data),
  updateSettings: (settings) => apiClient.put('/whatsapp/settings', settings).then(r => r.data),

  // Conversations
  getConversations: (params = {}) => apiClient.get('/whatsapp/conversations', { params }).then(r => r.data),
  getConversation: (id) => apiClient.get(`/whatsapp/conversations/${id}`).then(r => r.data),

  // Manueller Versand
  sendMessage: (conversationId, message) => apiClient.post('/whatsapp/send', { conversationId, message }).then(r => r.data),

  // Handoff (Übergabe an Mensch / KI wieder aktivieren)
  handoff: (conversationId, autoResumeMinutes) =>
    apiClient.put(`/whatsapp/conversations/${conversationId}/handoff`, { autoResumeMinutes }).then(r => r.data),
  resume: (conversationId) =>
    apiClient.put(`/whatsapp/conversations/${conversationId}/resume`).then(r => r.data),

  // Koexistenz (WhatsApp Business App + API parallel)
  enableCoexistence: () => apiClient.post('/whatsapp/enable-coexistence').then(r => r.data),

  // Meta Cloud API Verbindung
  connectMeta: (phoneNumberId, businessAccountId, phoneNumber) =>
    apiClient.post('/whatsapp/connect-meta', { phoneNumberId, businessAccountId, phoneNumber }).then(r => r.data),
  completeEmbeddedSignup: (code) =>
    apiClient.post('/whatsapp/embedded-signup-complete', { code }).then(r => r.data),
  getSenderStatus: () => apiClient.get('/whatsapp/sender-status').then(r => r.data),
  deleteSender: () => apiClient.delete('/whatsapp/sender').then(r => r.data),

  // Auto-Antwort-Sperre
  getAutoAntwortSperren: () => apiClient.get('/whatsapp/auto-antwort-sperre').then(r => r.data),
  addAutoAntwortSperre: (phone, grund) => apiClient.post('/whatsapp/auto-antwort-sperre', { phone, grund }).then(r => r.data),
  removeAutoAntwortSperre: (phone) => apiClient.delete(`/whatsapp/auto-antwort-sperre/${encodeURIComponent(phone)}`).then(r => r.data)
};
